// LAVA Perfumes - theme.js

// Cart drawer
function openCart(){var o=document.getElementById('cart-overlay');if(o)o.classList.add('open');}
function closeCart(){var o=document.getElementById('cart-overlay');if(o)o.classList.remove('open');}

// Toast
function showToast(msg){
  var t=document.getElementById('toast');
  if(!t)return;
  t.textContent=msg;
  t.classList.add('on');
  setTimeout(function(){t.classList.remove('on');},2800);
}

// Format money
function lavaMoney(cents){
  return 'EGP '+(cents/100).toLocaleString('en-EG',{minimumFractionDigits:2,maximumFractionDigits:2});
}

// Update cart drawer
function updateCartDrawer(cart){
  var countEls=document.querySelectorAll('#cart-count-d,.hdr-cart-badge');
  countEls.forEach(function(el){
    el.textContent=cart.item_count;
    el.style.display=cart.item_count>0?'flex':'none';
  });
  var body=document.getElementById('cart-body');
  if(!body)return;
  if(cart.item_count===0){
    body.innerHTML='<div class="cart-empty">Your cart is empty</div>';
    var tot=document.querySelector('.cart-total span:last-child');
    if(tot)tot.textContent=lavaMoney(0);
    return;
  }
  var html='';
  cart.items.forEach(function(item){
    var imgSrc=item.image?(item.image.indexOf('//')==0?'https:'+item.image:item.image):'';
    html+='<div style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid #f0f0f0">';
    if(imgSrc)html+='<img src="'+imgSrc+'" style="width:72px;height:80px;object-fit:cover;border-radius:6px;border:1px solid #eee" loading="lazy">';
    else html+='<div style="width:72px;height:80px;background:#f5f5f5;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:.7rem;color:#aaa">LAVA</div>';
    html+='<div style="flex:1">';
    html+='<div style="font-size:.82rem;font-weight:600;color:#111;margin-bottom:4px">'+item.product_title+'</div>';
    if(item.variant_title&&item.variant_title!=='Default Title')html+='<div style="font-size:.72rem;color:#aaa;margin-bottom:6px">'+item.variant_title+'</div>';
    html+='<div style="display:flex;justify-content:space-between;align-items:center">';
    html+='<div style="font-size:.82rem;font-weight:700">'+lavaMoney(item.final_price)+'</div>';
    html+='<div style="font-size:.75rem;color:#999">x'+item.quantity+'</div>';
    html+='</div></div></div>';
  });
  body.innerHTML=html;
  var tot=document.querySelector('.cart-total span:last-child');
  if(tot)tot.textContent=lavaMoney(cart.total_price);
}

// AJAX Add to Cart
document.addEventListener('DOMContentLoaded',function(){
  var form=document.getElementById('product-form');
  if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=form.querySelector('[type="submit"]');
    var origText=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding...';}
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){if(!r.ok)return r.json().then(function(d){throw new Error(d.description||'Error');});return r.json();})
    .then(function(){return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}});})
    .then(function(r){return r.json();})
    .then(function(cart){
      updateCartDrawer(cart);
      openCart();
      showToast('Added to cart!');
      if(btn){btn.disabled=false;btn.textContent=origText;}
    })
    .catch(function(err){
      showToast(err.message||'Could not add to cart');
      if(btn){btn.disabled=false;btn.textContent=origText;}
    });
  });
});

// Accordion
function toggleAcc(prefix,key){
  var allKeys=['him','her','uni'];
  var allCards=allKeys.map(function(k){return document.querySelector('[data-acc="'+prefix+'"][data-key="'+k+'"]');}).filter(Boolean);
  var allPanels=allKeys.map(function(k){return document.getElementById(prefix+'-panel-'+k);}).filter(Boolean);
  var targetPanel=document.getElementById(prefix+'-panel-'+key);
  var targetCard=document.querySelector('[data-acc="'+prefix+'"][data-key="'+key+'"]');
  var isOpen=targetPanel&&targetPanel.classList.contains('open');
  allCards.forEach(function(c){c.classList.remove('active');});
  allPanels.forEach(function(p){p.classList.remove('open');});
  if(!isOpen&&targetPanel&&targetCard){
    targetCard.classList.add('active');
    targetPanel.classList.add('open');
    setTimeout(function(){targetPanel.scrollIntoView({behavior:'smooth',block:'nearest'});},120);
  }
}

// Scroll top
window.addEventListener('scroll',function(){
  var btn=document.getElementById('scrollTop');
  if(btn)btn.classList.toggle('vis',window.scrollY>400);
});

// Hscroll drag
document.addEventListener('DOMContentLoaded',function(){
  var hs=document.getElementById('hscroll');
  if(!hs)return;
  var isDown=false,startX,scrollLeft;
  hs.addEventListener('mousedown',function(e){isDown=true;startX=e.pageX-hs.offsetLeft;scrollLeft=hs.scrollLeft;});
  hs.addEventListener('mouseleave',function(){isDown=false;});
  hs.addEventListener('mouseup',function(){isDown=false;});
  hs.addEventListener('mousemove',function(e){if(!isDown)return;e.preventDefault();var x=e.pageX-hs.offsetLeft;hs.scrollLeft=scrollLeft-(x-startX)*1.5;});
});

// Countdown
function startCountdown(targetDate){
  var h=document.getElementById('cd-h'),m=document.getElementById('cd-m'),s=document.getElementById('cd-s');
  function tick(){
    var diff=new Date(targetDate)-new Date();
    if(diff<=0)return;
    var hv=Math.floor(diff/3600000),mv=Math.floor((diff%3600000)/60000),sv=Math.floor((diff%60000)/1000);
    if(h)h.textContent=String(hv).padStart(2,'0');
    if(m)m.textContent=String(mv).padStart(2,'0');
    if(s)s.textContent=String(sv).padStart(2,'0');
  }
  tick();setInterval(tick,1000);
}
var cdTarget=new Date();cdTarget.setHours(23,59,59,0);
startCountdown(cdTarget);
